import { RootState } from '../../../../bll/store/store';

const isChangeUserDataLoadingSelector = (state: RootState) => state.salesSettings.isChangeUserDataLoading;

export { isChangeUserDataLoadingSelector };
